export enum Feature {
  HOME = 'home',
  ACCOUNTS = 'accounts',
  RECIPIENTS = 'recipients',
  TRANSACTIONS = 'transactions',
  TEAM = 'team',
  TASKS = 'tasks',
  ACTIONS = 'actions',
  SETTINGS = 'settings',

  // BE Features
  CONTRACTORS = 'CONTRACTORS',
  CARDS = 'CARDS',
  EURC_WALLET = 'EURC_WALLET',
}

export type Features = {
  features: Feature[]
}
